import ProposalSettings from '../proposalSettings/ProposalSettingsEntity';
import { DISCOUNT_TYPES, PriceProposalStatus } from './ProposalDC';

export { DISCOUNT_TYPES, PriceProposalStatus };

export interface ProposalItemEntity {
  description: string;
  qty: number;
  unitPrice: number;
}

export default interface ProposalEntity {
  uuid: string;
  number: number | null;
  title: string | null;
  client: string;
  subtotal_price: number;
  price_with_discount: number;
  tax_value: number;
  price_with_tax: number;
  status: PriceProposalStatus;
  description: string | null;
  discountType: DISCOUNT_TYPES;
  discountAmount: number;
  contactId: string;
  items: ProposalItemEntity[];
  isDraft: boolean;
  visible: boolean;
  sentAt: number | null; // timestamp in milliseconds or null
  createdAt: number | null; // timestamp in milliseconds
  updatedAt: number | null; // timestamp in milliseconds
  createdBy: string | null;
  updatedBy: string | null;
  settings: ProposalSettings;
  workspaceId: string;
  signedPdfUrl?: string | null;
}

/**
 * A quote the customer signed through the sign link is read-only (the server
 * refuses changes). A quote set to Accepted by hand has no signed PDF.
 */
export const isProposalSigned = (proposal?: Pick<ProposalEntity, 'status' | 'signedPdfUrl'>) =>
  proposal?.status === PriceProposalStatus.ACCEPTED && !!proposal.signedPdfUrl;
